var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupe3449(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.598,
    viewBox: "0 0 18 16.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3449",
    "data-name": "Groupe 3449",
    transform: "translate(-66.276 -55.896)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11796",
    "data-name": "Trac\\xE9 11796",
    d: "M81.492,56.156a4.629,4.629,0,1,1-3.09,4.938,4.665,4.665,0,0,1,3.09-4.938",
    transform: "translate(-7.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11797",
    "data-name": "Trac\\xE9 11797",
    d: "M84.276,91.525v-.006h0l0-.011a7.186,7.186,0,0,0-.45-1.571l-.061-.211-.028.005a6.631,6.631,0,0,0-3.071-3.254,5.771,5.771,0,0,0-1.449-.525v0l-.079-.016a11.784,11.784,0,0,0-2.594-.2c-.421,0-.843.007-1.264.01s-.843-.01-1.264-.01a11.784,11.784,0,0,0-2.594.2l-.079.016v0a5.774,5.774,0,0,0-1.449.525,6.629,6.629,0,0,0-3.071,3.254l-.028-.005-.061.211a7.185,7.185,0,0,0-.45,1.571l0,.011h0v.006l3.448,0q2.776,0,5.552,0h0q2.776,0,5.552,0Z",
    transform: "translate(0 -19.038)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe3449);
export default __webpack_public_path__ + "static/media/Groupe 3449.30ca95de31c0853460be97e738675815.svg";
export { ForwardRef as ReactComponent };